import React, { useState } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  Typography,
} from '@material-ui/core'
import { removeRepresentationIFI } from '../../../../../services/Representacion/create'
import Swal from 'sweetalert2'
import { useAuthentication } from '../../../../../context/authenticationContext'
export const ModalRepresentationIFI = ({
  open,
  setOpen,
  rowData,
  getMIPYMESRepresentadas,
}) => {
  const [body, setBody] = useState({
    Observation: '',
  })

  const handleClose = () => {
    setOpen(false)
  }
  const { userIDB2C } = useAuthentication()
  const handleGuardar = async () => {
    const values = {
      idMIPYME: rowData.IdMiPyme,
      Observation: body.Observation,
      idUserB2C: userIDB2C,
    }

    const response = await removeRepresentationIFI(values)
    if (response.Success) {
      Swal.fire({
        title: '¡Mipyme removida exitosamente!',
        icon: 'success',
      })

      handleClose()
      setOpen(false)
      getMIPYMESRepresentadas()
    } else {
      Swal.fire({
        title: 'Ocurrio un Error al remover la Mipyme...' + response.Message,
        icon: 'error',
      })
      getMIPYMESRepresentadas()
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <Grid className="modalTitle">
            <Typography
              id="modal-modal-title"
              style={{ fontWeight: '900' }}
              variant="h6"
              component="h2"
            >
              ELIMINAR REPRESENTACIÓN
            </Typography>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid
              container
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
              }}
            >
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Ingrese el motivo de la eliminación de la IFI{' '}
                        {rowData.IFIName}
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <textarea
                          id="Observation"
                          name="Observation"
                          placeholder="Motivo de eliminación de IFI"
                          customInput={TextField}
                          inputProps={{ maxLength: 250 }}
                          onChange={(e) => {
                            setBody({
                              ...body,
                              Observation: e.target.value,
                            })
                          }}
                          value={body.Observation}
                        ></textarea>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button className="confirmButton" onClick={handleGuardar}>
                  Rechazar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
